import { Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getArefToken, getPatientReport } from '../api/routes';
import Loading from '../components/Loading';
import RequestTable from '../components/RequestTable';
import { tokenInfo } from '../features/tab/tokenInfoSlice';

export default function Patient() {
    const [searchParams] = useSearchParams();
    const [codeReception, setCodeReception] = useState(null);
    const [patientData, setPatientData] = useState([]);
    const [requests, setRequests] = useState([])
    const [pacsResponse, setPacsResponse] = useState()
    const [loading, setLoading] = useState(false);
    const submitRef = useRef(null)
    const numberRegex = /^[0-9]*$/g;
    const tokenInformation = useSelector(tokenInfo);

    const codeReceptionChange = (event) => {
        if (event.target.value === '')
            return setCodeReception(event.target.value)
        else if (event.target.value.match(numberRegex)) {
            return setCodeReception(event.target.value)
        } else return alert('عدد وارد کنید!')
    }
    const onPatientClickEnter = (event) => {
        if (event.key === 'Enter' && codeReception !== '') {
            event.preventDefault();
            event.stopPropagation();
            submitRef.current.click()
        }
    }

    const patientReport = () => {
        if (codeReception && tokenInformation) {
            setLoading(true)
            getPatientReport(tokenInformation.api_route, codeReception, (isOk, data) => {
                if (!isOk) {
                    setLoading(false)
                    return alert(data.message);
                }
                else {
                    if (data.length === 0) {
                        setLoading(false)
                        return alert('بیمار یافت نشد!')
                    }
                    else {
                        setRequests(data.map((item, index) => ({ id: index, name: item.NameFarsi })));
                        setPatientData(data[0]);

                        if (tokenInformation.isPacs) {
                            getArefToken((isOk, data) => {
                                if (!isOk) {
                                    setLoading(false)
                                    return alert(data.message);
                                }
                                else {
                                    setLoading(false);
                                    setPacsResponse(data)
                                }
                            })
                        }
                        else return setLoading(false)
                    }
                }
            })
        } else return alert("شماره پذیرش را وارد کنید!")
    }
    useEffect(() => {
        if (searchParams.get("code") && tokenInformation) {
            setCodeReception(searchParams.get("code"));
            setTimeout(() => {
                submitRef?.current?.click();
            }, 100);
        }

    }, [searchParams.get("code"), tokenInformation])
    return (
        <>
            <Loading loading={loading} />
            <div className="h-full flex flex-col items-center justify-center" style={{ backgroundColor: "rgba(170, 220, 241,0.3)" }}>
                <div style={{ wordBreak: "break-word" }} className='flex flex-col flex-wrap justify-center bg-white w-[96%] sm:w-auto px-6 sm:px-8 py-12 rounded-lg shadow-lg'>
                    {patientData.length === 0 ? <><p className='font-bold mb-4 text-base sm:text-lg'>براي مشاهده گزارش به نكات ذيل توجه نماييد:</p>
                        <p className='text-sm sm:text-base'>• در كادر پايين شماره پذيرش بيمار را وارد نموده و كليد ادامه را بزنيد.</p>
                        <p className='my-4 text-sm sm:text-base'>• بعد از آماده شدن گزارش، پيامكي حاوي لينك مشاهده گزارش به تلفن همراه بيمار ارسال مي گردد.</p>
                        <p className='text-sm sm:text-base'>• درصورت داشتن سوال مي توانيد با شماره تلفن <span style={{}}>{tokenInformation?.tel}</span> تماس بگيريد.</p>
                        <div className='flex items-center flex-col sm:flex-row flex-wrap mt-8'>
                            <input onKeyDown={onPatientClickEnter} type='tel' value={codeReception} onChange={codeReceptionChange} placeholder="شماره پذیرش" className='flex-1 w-full sm:w-auto text-center border rounded-lg min-h-[44px] px-4' />
                            <button ref={submitRef} disabled={loading} type="button" onClick={patientReport} className='flex-1 w-full sm:w-auto sm:flex-none focus:outline-none text-white bg-[#fa3668] font-medium rounded-lg px-8 sm:px-12 py-2.5 mt-4 sm:mt-0 sm:mr-4'>ادامه</button>
                        </div></> : <section className='sm:w-[450px] relative'>
                        <img src='/images/back-arrow.png' alt='back-arrow' className='absolute -left-5 sm:-left-7 -top-10 w-9 cursor-pointer' onClick={() => setPatientData([])} />
                        <p className='sm:text-base text-sm font-bold'><span className='font-normal'>تاریخ مراجعه: </span>{patientData.DateReception}</p>
                        <p className='sm:text-base my-2 text-sm font-bold'><span className='font-normal'>مراجعه کننده محترم: </span>{patientData.fullName}</p>
                        <p className='sm:text-base text-sm font-bold'><span className='font-normal'>نوع خدمت: </span>{patientData.NameGroups}</p>

                        <section className='flex flex-col items-center mt-6'>
                            <Button disabled={loading} className='w-3/4' onClick={() => window.open(`http://${tokenInformation.pacs_ip_report}/index.aspx?code=${codeReception}`)} variant="outlined" style={{ color: "#068dd6", borderColor: "#068dd6" }}>
                                <img src='/images/word.png' alt='report' className='cursor-pointer w-10 ml-4' />
                                <p className='sm:text-base text-sm'>مشاهده جواب</p>
                            </Button>
                            <Button disabled={loading} className='mt-2 w-3/4' onClick={() => pacsResponse.length > 0 && window.open(`http://2.180.27.231/metric/HisIntegration.aspx?ID=${codeReception}&JWT=${pacsResponse}`, "_blank")} variant="outlined" style={{ color: "#068dd6", borderColor: "#068dd6" }}>
                                <img src='/images/pic.png' alt='pacs' className={`cursor-pointer w-10 ml-4`} />
                                <p className='sm:text-base text-sm'>مشاهده تصاویر</p>
                            </Button>
                        </section>

                        <p className='mt-4 mb-2 sm:text-base text-sm'>جزئیات درخواست:</p>
                        <RequestTable data={requests} />
                    </section>}

                </div>
                {/* <p className='pt-8 sm:pt-16'>ساخته شده با ❤️ در <a href='https://gerafi.com' className="text-[#068dd6] font-bold" rel="noreferrer" target="_blank">گرافی دات کام</a></p> */}
            </div>

        </>
    )
}